import React from 'react'

const messageFailure = () =>{

    return(
    <div className='fail'>
        <h1>Error! Please try again!</h1>
    </div>
    )
}

export default messageFailure